import { DatePipe } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { NgModel } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiService } from 'app/api-services/api.service';
import moment from 'moment';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-create-or-edit-branch-peak-timings-component',
  templateUrl: './create-or-edit-branch-peak-timings-component.component.html',
  styleUrls: ['./create-or-edit-branch-peak-timings-component.component.scss']
})
export class CreateOrEditBranchPeakTimingsComponentComponent {

  @ViewChild('proRataPercentageField') proRataPercentageField: NgModel;

  constDaysList = [
    { value: 'SUN', viewValue: 'Sunday' },
    { value: 'MON', viewValue: 'Monday' },
    { value: 'TUE', viewValue: 'Tuesday' },
    { value: 'WED', viewValue: 'Wednesday' },
    { value: 'THU', viewValue: 'Thursday' },
    { value: 'FRI', viewValue: 'Friday' },
    { value: 'SAT', viewValue: 'Saturday' },
  ]

  allDaysList = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT']
  daysList = JSON.parse(JSON.stringify(this.constDaysList));

  allComplete: boolean = false

  dayType = [
    // { value: 'PEAK_TIME', viewValue: 'Peak Time' },
    { value: 'OFF_PEAK_TIME', viewValue: 'Off Peak Time' },
  ]
  branchId: string;
  branchName: string;

  isUpdate: boolean = true

  startTime: string;
  endTime: string;
  proRataPercentage: number;
  selectedDay = [];
  selectedDay_type: string = '';
  days: string[] = [];
  daysType: string;
  timeSlots = [];
  selectedTimeSlots = [];
  sortedTimeSlots = []

  disableAdd: boolean = true;
  disableTime: boolean = true;

  convertedTime: string;
  daysArray = []
  newDate: any;
  myDate = new Date();
  userTimeZone: string;

  showErrorMsgToAddTimeSlots: boolean = false;
  errorMsgToAddTimeSlots: string = '';

  title: string = "UPDATE BRANCH PEAK TIMINGS"

  constructor(
    public apiService: ApiService,
    private router: Router,
    private toastr: ToastrService,
    private datePipe: DatePipe
  ) {
    this.branchId = sessionStorage.getItem('editBranchPeakTimingsForBranchId');
    this.branchName = sessionStorage.getItem('editBranchPeakTimingsForBranchName');
  }

  async ngOnInit() {
    this.getUserTimeZone()
    this.getBranchPeakTimingsByBranchId()
  }

  back() {
    sessionStorage.removeItem('editBranchPeakTimingsForBranchId')
    this.router.navigateByUrl('Admin/branches');
  }

  getUserTimeZone(): void {
    this.userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  }

  getBranchPeakTimingsByBranchId() {

    this.apiService.getBranchPeakTimingsById(this.branchId).subscribe((resp) => {
      if (resp.status == "success") {

        this.selectedTimeSlots = resp.data.peak_times;
        this.selectedTimeSlots.forEach(element => {
          element.start_time = this.convertToIst(element.start_time);
          element.end_time = this.convertToIst(element.end_time)
        });

        // Filling the days array, so that we won't update it
        this.selectedTimeSlots.forEach((element: any) => {
          if (!this.daysArray.includes(element.day_of_week)) {
            this.daysArray.push(element.day_of_week)
          }
        });

        const convertTime = timeStr => {
          let zone = "AM"
          if (timeStr != null) {
            timeStr = moment(timeStr).format("HH:mm:ss");
            let [hours, minutes, seconds] = timeStr.split(':');
            if (hours >= '12') {
              zone = "PM"
              if (hours > '12') {
                hours = parseInt(hours, 10) - 12;
              } else {
                hours = parseInt(hours, 10);
              }
            }
            if (hours < '10' && typeof (hours) == 'number') {
              hours = '0' + hours
            }
            if (hours == '00') {
              hours = '12'
            }

            return `${hours}:${minutes} ${zone}`;
          } else {
            return null;
          }
        }

        const newdata = resp.data.peak_times.map((ele) => {
          return ({
            "day": this.constDaysList.find(each => each.value == ele.day_of_week).viewValue,
            "startTime": convertTime(ele.start_time),
            "endTime": convertTime(ele.end_time),
            "pro_rata_percentage": ele.pro_rata_percentage,
            "dayType": ele.timing_type
          })
        })
        this.timeSlots = newdata;
        this.sortTimeSlots()
      }
    }, (err) => {
      this.toastr.error(err.error.message);
    })
  }

  convertToIst(date: any) {
    if (date != null) {
      this.newDate = this.datePipe.transform(this.myDate, 'YYYY-MM-dd');
      date = this.newDate + " " + date;
      return date
    } else {
      return null
    }
  }

  selectedDays(event) {
    let selectedDayValues = [...event];
    if (selectedDayValues.length >= 7) {
      this.allComplete = true
    } else {
      this.allComplete = false
    }
    this.selectedDay = []
    this.days = []
    selectedDayValues.forEach(selectedDayValue => {
      let selectedObj = this.daysList.find(each => each.value === selectedDayValue)
      this.selectedDay.push({ "value": selectedObj.value, "viewValue": selectedObj.viewValue });
      this.days.push(selectedObj.value)
    });

    // We are fixing the day_type as PEAK TIME ONLY
    this.selectedDayType('OFF_PEAK_TIME')
  }

  selectedDayType(event) {
    let selectedTypeObj = this.dayType.find(each => each.value === event);
    this.selectedDay_type = selectedTypeObj.viewValue;
    this.daysType = selectedTypeObj.value;
    this.disableTime = false;
  }

  deleteDay(slot) {
    let i = this.timeSlots.findIndex(timeSlot => JSON.stringify(timeSlot) == JSON.stringify(slot))
    this.timeSlots.splice(i, 1);
    this.selectedTimeSlots.splice(i, 1)
    this.sortTimeSlots()

    this.someComplete()
  }

  addTimeSlots() {
    this.showErrorMsgToAddTimeSlots = false;

    if (this.selectedDay.length <= 0 && this.selectedDay_type) {
      this.showErrorMsgToAddTimeSlots = true;
      this.errorMsgToAddTimeSlots = 'Please select a day before adding';
      setTimeout(() => {
        this.resetTimeSlots()
      }, 1000);
      return
    }

    if (this.endTime && this.startTime) {
      var endTime = moment(new Date(this.endTime)).format("hh:mm A").toString();
      var strTime = moment(new Date(this.startTime)).format("hh:mm A").toString();
      var enTime = moment(new Date(this.endTime)).format("YYYY-MM-DD HH:mm:ss").toString();
      var stTime = moment(new Date(this.startTime)).format("YYYY-MM-DD HH:mm:ss").toString();
    } else if (this.selectedDay_type == 'Peak Time') {
      this.showErrorMsgToAddTimeSlots = true;
      this.errorMsgToAddTimeSlots = 'Please select valid Start Time and End Time before adding';
      setTimeout(() => {
        this.resetTimeSlots()
      }, 1000);
      return
    } else {
      this.endTime = null
      this.startTime = null
    }

    let areTimeslotsAddable = true;
    let tempTimeSlots = []
    let tempSelectedTimeSlots = [];
    let overlappingTimeDays = []

    this.selectedDay.forEach(selectedDay => {
      if ((this.endTime != null || undefined) && (this.startTime != null || undefined)) {
        let object = {
          day: selectedDay.viewValue,
          dayType: this.selectedDay_type,
          startTime: strTime,
          endTime: endTime,
          pro_rata_percentage: this.proRataPercentage,
        }
        tempTimeSlots.push(object);
        let obj = {
          day_of_week: selectedDay.value,
          day_type: this.daysType,
          start_time: stTime,
          end_time: enTime,
          pro_rata_percentage: this.proRataPercentage,
        }
        tempSelectedTimeSlots.push(obj);
        // Checking for the existence of overlapping timings
        this.selectedTimeSlots.forEach(e => {
          let e_start_time = new Date(e.start_time)
          let e_end_time = new Date(e.end_time)
          let obj_start_time = new Date(obj.start_time)
          let obj_end_time = new Date(obj.end_time)

          if (
            e.day_of_week == selectedDay.value && (
              (e_start_time <= obj_start_time && obj_start_time <= e_end_time) ||
              (e_start_time <= obj_end_time && obj_end_time <= e_end_time) ||
              (obj_start_time <= e_start_time && e_end_time <= obj_end_time)
            )
          ) {
            areTimeslotsAddable = false
            if (overlappingTimeDays.indexOf(selectedDay.viewValue) == -1) {
              overlappingTimeDays.push(selectedDay.viewValue)
            }
          }
        })
      }
    });

    if (areTimeslotsAddable) {
      tempTimeSlots.forEach(dayTimeObj => {
        if (dayTimeObj) {
          this.timeSlots.push(dayTimeObj)
        }
      })
      tempSelectedTimeSlots.forEach(dayTimeObj => {
        if (dayTimeObj) {
          this.selectedTimeSlots.push(dayTimeObj)
        }
      })
      this.sortTimeSlots()

      this.resetTimeSlots()

    } else {
      this.showErrorMsgToAddTimeSlots = true
      this.errorMsgToAddTimeSlots = "Overlapping times given for " + overlappingTimeDays.join(', ')
      setTimeout(() => {
        this.resetTimeSlots()
      }, 1000);
    }
  }

  sortTimeSlots() {
    // todo: this sorting still has a problem, it is not sorint when we add PM times first and then AM times
    let daysListInOrder = []
    this.constDaysList.forEach(elem => {
      if (!daysListInOrder.includes(elem.viewValue)) {
        daysListInOrder.push(elem.viewValue)
      }
    })
    this.sortedTimeSlots = structuredClone(this.timeSlots)

    this.sortedTimeSlots = this.sortedTimeSlots.sort(
      (a, b) => (daysListInOrder.indexOf(a.day) < daysListInOrder.indexOf(b.day)) ? -1 : (daysListInOrder.indexOf(a.day) > daysListInOrder.indexOf(b.day)) ? 1 : 0
    ).sort(
      (a, b) => {
        if (((daysListInOrder.indexOf(a.day) < daysListInOrder.indexOf(b.day)) ? -1 : (daysListInOrder.indexOf(a.day) > daysListInOrder.indexOf(b.day)) ? 1 : 0) == 0 && a.dayType == 'Peak Time') {
          var nowDate = new Date().toISOString().split('T')[0];
          let aZone = a.startTime.slice(-3,)
          let bZone = b.startTime.slice(-3,)

          var astartTime = new Date(nowDate + ' ' + a.startTime.slice(0, -2));
          var bstartTime = new Date(nowDate + ' ' + b.startTime.slice(0, -2))

          if (aZone == bZone) {
            return (astartTime < bstartTime) ? -1 : (astartTime > bstartTime) ? 1 : 0
          } else if (aZone == 'PM' && bZone == 'AM') {
            return 1
          } else if (aZone == 'AM' && bZone == 'PM') {
            return -1
          }
        }
      }
    )
  }

  updatePeakTimingAddableOrNot() {
    if (this.proRataPercentage && this.proRataPercentage > 0.01) {
      this.disableAdd = false;
      this.proRataPercentage = parseFloat(this.proRataPercentage.toFixed(2));
    } else {
      this.disableAdd = true;
    }
  }

  resetTimeSlots() {
    this.selectedDay = [];
    this.startTime = "";
    this.endTime = "";
    this.days = [];
    this.selectedDay_type = "";
    this.daysType = ""
    this.showErrorMsgToAddTimeSlots = false;
    this.disableAdd = true;
    this.disableTime = true;
    this.proRataPercentage = null;
    this.proRataPercentageField.reset(null);
  }

  createOrUpdateBranch() {

    let payload = this.selectedTimeSlots;

    this.apiService.createBranchPeakTimingsById(this.branchId, payload).subscribe((resp) => {
      if (resp.status == "success") {
        this.router.navigateByUrl('Admin/branches');
      }
    },
      (err) => {
        this.toastr.error(err.error.message)
      })
  }

  isCreateOrUpdatebranchValid() {
    return this.timeSlots.length>0;
  }

  someComplete(): boolean {
    if (this.days.length == this.daysList.length) {
      this.allComplete = true
    } else {
      this.allComplete = false
    }

    return this.days.length > 0 && !this.allComplete;
  }

  setAll(change) {
    if (change.checked) {
      this.allComplete = true;
      this.days = this.daysList.map(e => e.value);
    } else {
      this.allComplete = false;
      this.days = [];
    }
    this.selectedDays(this.days)
  }

}
